<template>
  <va-modal
    size="large"
    id="lead-session-transfer-modal"
    ref="sessionTransferModal"
    v-model="showSessionTransferModal"
    :okToClose="canClose"
    :okText="$t('users.save')"
    :okDisabled="isSubmitting || !newSelectedSession"
    @ok="updateSession" @cancel="closeLeadTransfer"
    :cancelText="$t('users.cancel')"
    :noOutsideDismiss="true"
  >
    <div slot="header" class="modal-title">
      {{getTitleHeader}}
    </div>

    <div v-if="availabilities.length > 0">
      <h6 class="is-bold">
        {{$t('leads.transfer_session.sessions_for_interval', {dayStart: getStartDateForSessions(), dayEnd: getEndDateForSessions()})}}
      </h6>

      <div class="mt-3">
        <div v-for="(screening, i) in availabilities" :key="i" class="section-row">
          <div class="row screening-wrapper align-items-center">
            <div class="col-sm-12 promotion-date-span col-lg-2">
              <span class="fc-event-dot d-md-none" style="background-color:#29c4a9;"></span>
              <div v-if="screeningIntervalSameDay(screening)">
                <div>
                  {{ getScreeningDay(screening) }}
                </div>
                <div>
                  {{ getScreeningStartEndInterval(screening) }}
                </div>
              </div>
              <div v-else>
                <div>
                  {{ getStartTimeInformation(screening) }}
                </div>
                <div>
                  {{ getEndTimeInformation(screening) }}
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-12 promotion-facility-span align-middle">
              {{screening.facility.name}}<br>
              <span class="screening-facility-address">
                {{getFacilityAddressInformation(screening.facility)}}
              </span>
            </div>
            <div class="col-sm-12 promotor-span col-lg-3">
              <span v-if="getPromotorInformation(screening.user)" class="">
                {{ getPromotorInformation(screening.user)}}&nbsp;
              </span>
              <span v-else> {{ $t('agenda.undefined_promoter')}}</span>
            </div>
            <div class="col-sm-12 col-lg-2 kiosk-span">
              {{ presentKiosk(screening) }}
            </div>
            <div class="col-sm-12 col-lg-1 pr-0 promotion-action-buttons">
              <va-radio-button
                  :key="i"
                  :option="screening.id"
                  :value="newSelectedSession ? newSelectedSession.id : null"
                  @input="selectedSessionChanged(screening)"
                />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <span class="d-flex justify-content-center pt-2 pb-2">
        {{ $t('leads.transfer_session.no_availabilities_found') }}
      </span>
    </div>
  </va-modal>
</template>
<script>
export default {
  props: {
    selectedLead: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showSessionTransferModal: false,
      isLoading: false,
      newSelectedSession: null,
      canClose: true,
      isSubmitting: false,
      availabilities: []
    }
  },
  mounted () {
    this.loadSimiliarSessions()
  },
  methods: {
    presentKiosk: function (screening) {
      return screening.kiosk ? screening.kiosk.name : this.$t('agenda.screenings.labels.undefined_kiosk')
    },
    getFullDescription: function (screening) {
      let result = { date: '', place: '', promoter: '' }
      if (this.screeningIntervalSameDay(screening)) {
        result.date += this.getScreeningDay(screening) + ' '
        result.date += this.getScreeningStartEndInterval(screening)
      } else {
        result.date += this.getStartTimeInformation(screening) + ''
        result.date += this.getEndTimeInformation(screening)
      }
      result.place = screening.facility.name + ' - ' + this.getFacilityAddressInformation(screening.facility)
      result.promoter = this.getPromotorInformation(screening.user)

      return result
    },
    selectedSessionChanged: function (screening) {
      this.newSelectedSession = screening
    },
    getScreeningDay: function (screening) {
      return `${screening.start.substring(0, screening.start.length - 9)}`
    },
    getStartTimeInformation: function (screening) {
      return `${screening.start.substring(0, screening.start.length - 3)}`
    },
    getEndTimeInformation: function (screening) {
      return `${screening.end.substring(0, screening.end.length - 3)}`
    },
    getScreeningStartEndInterval (screening) {
      return `${this.moment(screening.start).format('HH:mm')} - ${this.moment(screening.end).format('HH:mm')}`
    },
    screeningIntervalSameDay (screening) {
      return this.moment(screening.start).isSame(this.moment(screening.end), 'day')
    },
    getFacilityAddressInformation: function (facility) {
      if (facility.address) {
        return `(${facility.address.line1} - ${facility.address.city})`
      }
    },
    getPromotorInformation: function (promotor) {
      return promotor ? promotor.name : null
    },
    loadSimiliarSessions: function () {
      this.isLoading = true
      let params = {
        startDate: this.getStartDateForSessions(),
        endDate: this.getEndDateForSessions(),
        activities: 3
      }
      this.$http({
        url: `${this.$store.state.ebooking_server}/availabilities`,
        params
      }).then((response) => {
        this.availabilities = response.data.data
        this.showSessionTransferModal = true
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    getStartDateForSessions: function () {
      //Se o dia for uma segunda, o anterior a considerar terá de ser sábado
      const momentDate = this.moment(this.selectedLead.created_at)
      if(momentDate.isoWeekday() === 1) {
        return momentDate.subtract(2, 'day').format('YYYY-MM-DD')
      } else {
        return momentDate.subtract(1, 'day').format('YYYY-MM-DD')
      }
    },
    getEndDateForSessions: function () {
      //Se o dia for um sabado, o seguinte a considerar terá de ser segunda
      const momentDate = this.moment(this.selectedLead.created_at)
      if(momentDate.isoWeekday() === 6) {
        return momentDate.add(2, 'day').format('YYYY-MM-DD')
      } else {
        return momentDate.add(1, 'day').format('YYYY-MM-DD')
      }
    },
    updateSession: function () {
      this.$http({
        url: `${this.$store.state.evollead_server}/leads/${this.selectedLead.id}/session`,
        method: 'POST',
        data: { session_id: this.newSelectedSession.id }
      }).then((response) => {
        const lead = response.data.data
        this.$emit('updatedSession', { lead })
        this.showToast(this.$t('leads.transfer_session.success'), this.$store.state.successToastOptions)
      }).catch((err) => {
        console.log(err)
      })
    },
    closeLeadTransfer: function () {
      this.$emit('closeLeadModal')
    }
  },
  computed: {
    getTitleHeader: function () {
      return this.$t('leads.transfer_session.title') + ` ${this.selectedLead.name}` + (this.selectedLead.surname ? ` ${this.selectedLead.surname}` : '')
    }
  }
}
</script>

<style lang="scss">

  #lead-session-transfer-modal {
    .va-radio-button {
      .va-radio-button__slot-container {
        display: none !important;
      }
    }

    @media only screen and (max-width : 992px) {
      .promotion-date-span {
        display: flex;
        justify-content: center;
        order:1;
      }

      .promotion-facility-span {
        display: flex;
        justify-content: center;
        order: 3;
      }

      .promotor-span {
        display: flex;
        justify-content: center !important;
        order: 2;
      }

      .screening-facility-address{
        margin-bottom: 0px !important;
      }

      .kiosk-span {
        display: flex;
        justify-content: center;
        order: 4;
      }

      .promotion-action-buttons {
        display: flex;
        justify-content: space-around;
        order: 5;
      }

      .fc-event-dot {
        display: none !important;
      }

      .screening-date-time{
        font-size: 15px;
        margin-left: 3px;
        margin-top: 2px;
      }

      .screening-facility-address{
        font-size: 15px;
        margin-top: 1px;
        margin-left: 2px;
      }
    }

    .promotor-span {
      min-width:15% !important;
    }

    .screening-date-time{
      font-size: 14px;
    }

    .screening-facility-address{
      font-size: 14px;
    }

    #screenings-widget {
      min-height: 85vh;
    }

    .custom-bullseye {
      color: #29c4a9;
    }

    .custom-qrcode{
      color: #29c4a9;
    }

    .custom-pen{
      color: #29c4a9;
    }

    .fa-qrcode:hover {
      cursor: pointer;
    }

    .ion-md-clipboard {
      margin-left: 0.25rem;
      color: #29c4a9;
      font-size: 16px;
    }

    .loading-wrapper {
      height: 70vh;
    }

    .qrcode-sent {
      color: #29c4a9;
    }

    .section-wrapper {
      border: solid 1px #ddd;
      border-radius: 0.2em;
      border-left: 0px;
      border-right: 0px;
      margin-bottom: 1.25em;
    }
    .section-row, .section-title{
      padding: 0.8em 1.25em 0.8em 1.25em;
      cursor: pointer;
    }

    .section-title {
      background: #eee;
      font-weight: bold;
      border-top-left-radius: 0.2em;
      border-top-right-radius: 0.2em;
    }

    .selected-session {
      margin-top: 1rem;
      margin-bottom: 2rem;
      .selected-session-details {
        padding-left: calc(1.25em + 15px);
        p {
          margin-bottom: 0.5rem;
        }
      }
    }

    // .section-row:not(:last-child){
    //   border-bottom: solid 1px #ddd;
    // }

    .section-row {
      &:nth-of-type(even) {
        background-color: #e8e8e8;
      }
      &.selected {
        background-color: $evollu-dark;
        color: white !important;
        .va-radio-button__icon {
          border-color: rgb(255, 29, 94) !important;
        }
      }
    }

    .fc-event-dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      margin-right: 0.5em;
    }

    .icon-green {
      color: #29c4a9;
    }
  }
</style>
